<template>
  <div>
    <el-row style="height: 60px; line-height: 60px">
      <el-col :span="12" style="text-align: left; font-size: 20px; color: #0a666b">
        <span class="el-icon-s-check" style="font-size: 22px"></span>
        {{ $t('preprint.pendingTitle') }}
      </el-col>
    </el-row>

    <el-row v-if="preprintList.length == 0">
      <el-col :span="24">
        <el-empty
          :description="$t('preprint.pendingEmpty')"
          style="height: 900px; background-color: white"
        ></el-empty>
      </el-col>
    </el-row>

    <el-row style="min-height: 900px">
      <el-col :span="24" style="margin-top: 10px">
        <el-card
          class="box-card"
          shadow="hover"
          v-for="(item, index) in preprintList"
          :key="index"
        >
          <div slot="header" class="clearfix">
            <span style="color: #0a666b; font-weight: 900; float: left; max-width: calc(100% - 100px); overflow: hidden; text-overflow: ellipsis; white-space: nowrap; display: inline-block;">
              《{{ item.title }}》
            </span>
            <el-tag type="warning" size="small" style="float: right">
              {{ $t('preprint.myStatusPending') }}
            </el-tag>
          </div>
          <el-row>
            <el-col :span="18">
              <el-row>
                <el-col :span="12" style="text-align: left; margin-top: 10px">
                  <span style="color: #0a666b">{{ $t('preprint.pendingSubmitter') }}:</span>
                  {{ item.submitterName }} ({{ item.submitterEmail }})
                </el-col>
                <el-col :span="12" style="text-align: left; margin-top: 10px">
                  <span style="color: #0a666b">{{ $t('preprint.pendingType') }}:</span>
                  {{ item.preprintType }}
                </el-col>
                <el-col :span="24" style="text-align: left; margin-top: 10px">
                  <span style="color: #0a666b">{{ $t('preprint.pendingAbstract') }}:</span>
                  {{ item.abstractText }}
                </el-col>
                <el-col :span="12" style="text-align: left; margin-top: 10px">
                  <span style="color: #0a666b">{{ $t('preprint.pendingSubmitTime') }}:</span>
                  {{ item.submitTime }}
                </el-col>
              </el-row>
            </el-col>
            <el-col :span="6" style="text-align: right">
              <el-button
                size="small"
                type="primary"
                @click="viewDetail(item.id)"
                style="background-color: #09666c; border: none; margin-bottom: 5px"
              >
                {{ $t('preprint.pendingViewDetail') }}
              </el-button>
              <br />
              <el-button
                size="small"
                type="success"
                @click="openAuditDialog(item, true)"
                style="margin-bottom: 5px"
              >
                {{ $t('preprint.pendingApprove') }}
              </el-button>
              <br />
              <el-button
                size="small"
                type="danger"
                @click="openAuditDialog(item, false)"
              >
                {{ $t('preprint.pendingReject') }}
              </el-button>
            </el-col>
          </el-row>
        </el-card>

        <br />
        <el-pagination
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :current-page="currentPage"
          :page-sizes="[10, 20, 30, 50]"
          :page-size="pageSize"
          layout="total, sizes, prev, pager, next, jumper"
          :total="pageTotal"
        >
        </el-pagination>
      </el-col>
    </el-row>

    <!-- 审核对话框 -->
    <el-dialog
      :title="auditForm.approved ? $t('preprint.pendingDialogApproveTitle') : $t('preprint.pendingDialogRejectTitle')"
      :visible.sync="auditDialogVisible"
      width="500px"
    >
      <el-form :model="auditForm" label-width="100px">
        <el-form-item :label="$t('preprint.detailTitle')">
          <span>{{ auditForm.title }}</span>
        </el-form-item>
        <el-form-item :label="$t('preprint.pendingDialogOpinion')" required>
          <el-input
            type="textarea"
            :rows="4"
            v-model="auditForm.opinion"
            :placeholder="auditForm.approved ? $t('preprint.pendingDialogOpinionPlaceholderApproved') : $t('preprint.pendingDialogOpinionPlaceholderRejected')"
          ></el-input>
        </el-form-item>
      </el-form>
      <span slot="footer">
        <el-button @click="auditDialogVisible = false">{{ $t('preprint.pendingDialogCancel') }}</el-button>
        <el-button
          :type="auditForm.approved ? 'success' : 'danger'"
          @click="submitAudit"
          :loading="auditing"
        >
          {{ auditForm.approved ? $t('preprint.pendingDialogConfirmApprove') : $t('preprint.pendingDialogConfirmReject') }}
        </el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import { getPendingPreprintList, auditPreprint } from '@/api/preprint'

export default {
  name: 'pendingPreprintList',
  data() {
    return {
      userInfo: null,
      preprintList: [],
      currentPage: 1,
      pageSize: 10,
      pageTotal: 0,
      auditDialogVisible: false,
      auditing: false,
      auditForm: {
        preprintId: '',
        title: '',
        approved: true,
        opinion: ''
      }
    }
  },
  methods: {
    viewDetail(id) {
      this.$router.push({
        name: 'preprintDetail',
        query: { id: id }
      })
    },
    openAuditDialog(item, approved) {
      this.auditForm = {
        preprintId: item.id,
        title: item.title,
        approved: approved,
        opinion: ''
      }
      this.auditDialogVisible = true
    },
    submitAudit() {
      if (!this.auditForm.approved && !this.auditForm.opinion) {
        this.$message.warning(this.$t('preprint.pendingNeedRejectReason'))
        return
      }

      this.auditing = true
      auditPreprint({
        userInfo: {
          email: this.userInfo.email,
          name: this.userInfo.name
        },
        preprintId: this.auditForm.preprintId,
        approved: this.auditForm.approved,
        opinion: this.auditForm.opinion
      }).then((res) => {
        if (res.data.errorCode === 0) {
          this.$message.success(this.auditForm.approved ? this.$t('preprint.pendingApproveSuccess') : this.$t('preprint.pendingRejectSuccess'))
          this.auditDialogVisible = false
          this.loadPendingList()
        } else {
          this.$message.error(res.data.errorMessage || this.$t('preprint.pendingAuditFailed'))
        }
      }).catch((err) => {
        console.error('审核错误:', err)
        this.$message.error(this.$t('preprint.pendingAuditFailed'))
      }).finally(() => {
        this.auditing = false
      })
    },
    handleSizeChange(val) {
      this.pageSize = val
      this.loadPendingList()
    },
    handleCurrentChange(val) {
      this.currentPage = val
      this.loadPendingList()
    },
    loadPendingList() {
      getPendingPreprintList({
        userInfo: {
          email: this.userInfo.email,
          type: this.userInfo.type
        },
        current: this.currentPage,
        size: this.pageSize
      }).then((res) => {
        if (res.data.errorCode === 0) {
          this.preprintList = res.data.result.records || []
          this.pageTotal = res.data.result.total || 0
        } else {
          this.$message.error(res.data.errorMessage || this.$t('preprint.pendingLoadFailed'))
        }
      }).catch((err) => {
        console.error('加载待审核列表错误:', err)
        this.$message.error(this.$t('preprint.pendingLoadFailed'))
      })
    }
  },
  mounted() {
    // 获取用户信息
    const userInfoStr = this.$cookie.getCookie('userInfo')
    
    if (!userInfoStr) {
      this.$message.error(this.$t('preprint.needLogin'))
      this.$router.push({ name: 'login' })
      return
    }
    
    // vue-cookies 已经自动反序列化了，直接使用
    this.userInfo = userInfoStr
    
    // 检查是否是管理员
    if (this.userInfo.type !== '责任编辑') {
      this.$message.error(this.$t('preprint.noAuthWithRole', { role: this.userInfo.type }))
      this.$router.push({ name: 'index' })
      return
    }
    
    this.loadPendingList()
  }
}
</script>

<style scoped>
.box-card {
  width: 100%;
  border-radius: 10px;
  margin-bottom: 10px;
}

/* 卡片头部样式，确保标题完整显示 */
.clearfix {
  min-height: 40px;
  padding: 10px 0;
  line-height: 1.5;
  overflow: visible;
}

.clearfix::after {
  content: "";
  display: table;
  clear: both;
}
</style>




// WEBPACK FOOTER //
// src/view/preprint/admin/pendingPreprintList.vue